<script setup>
import { Link } from '@inertiajs/vue3';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
    links: Object,
});
</script>

<template>
    <div v-if="links.contents">
        <p class="mt-8 mb-4 text-xl font-black md:text-2xl md:mt-0">{{ t('Pages') }}</p>

        <div class="grid grid-cols-2 gap-x-10 gap-y-2 md:grid-cols-1">
            <ul class="space-y-2">
                <li v-for="item in links.contents" :key="item.id">
                    <Link v-if="item.data.url" :href="item.data.url" class="transition duration-300 group">
                        <span v-if="item.data.title"> {{ item.data.title }}</span>
                        <span
                            class="block max-w-8 group-hover:max-w-16 transition-all duration-500 h-[1px] bg-primary"
                        ></span>
                    </Link>
                </li>
            </ul>
        </div>
    </div>
</template>
